module.exports = __webpack_public_path__ + "static/media/people-leadership-footer.0f9332b1.png";